import { RCCServicesApi } from "react-common-components";
import { IDataTable, IUrlMemorizedParams, IValuesTable } from "./interface";

const executeQueryIncomeChildren = async (origin: number, memorizedUrlParams: IUrlMemorizedParams, lineIdFather: number, lineId?: number, baseVerticalValues?: IValuesTable[], valuesOfQuantity?: IValuesTable[]) => {
	const {data} = await RCCServicesApi.postRequest({
		method: "FinancialManagement/IncomeStatementChildren",
		urlParameters: {
			origin,
			lineIdFather,
			lineId: lineId || "",
			...memorizedUrlParams
		},
		body: {
			baseVerticalValues: baseVerticalValues || null,
			valuesOfQuantity: valuesOfQuantity || null
		}
	});
	const listIncomeStatements = data as IDataTable[];

	return listIncomeStatements;
};

export default executeQueryIncomeChildren;
